import { Injectable } from '@angular/core';
import { UserService } from '../services/user.service';
@Injectable(
    // {  providedIn:'root', }
)



export class GetCourseTreeObject {

    constructor(private userService: UserService) {

    }

    categories: any[] = [];

    setEntity(categories): void {
        this.categories = categories;
    }
}


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/stores/usercourseTreeobject.store.ts